import { Grid, Typography } from "@material-ui/core";
import SimpleTable from "../CustomTable/SimpleTable";
import CustomPagination from "../CustomPagination/CustomPagination";
import OrderSelect from "./OrderSelect";
import { renderTimeJalali } from "../../utils/TimeUtils";

const DeviceOrders = ({
  orderTypes,
  orders,
  orderPage,
  updateTable,
  deviceInfo,
  changePage,
}) => {
  const renderStatus = (orderStatus) => {
    return orderStatus ? (
      <span
        style={{
          background: "green",
          color: "white",
          padding: "0 3px",
          borderRadius: "3px",
        }}
      >
        انجام شده
      </span>
    ) : (
      <span
        style={{
          background: "red",
          color: "white",
          padding: "0 3px",
          borderRadius: "3px",
        }}
      >
        انجام نشده
      </span>
    );
  };
  let total_orders = orders[0]?.all_orders_number;
  let total_pages =
    total_orders % 10 !== 0
      ? Math.floor(total_orders / 10) + 1
      : total_orders / 10;
  const styles = {
    header: { textAlign: "start", padding: "5px 15px", marginTop: "10px" },
    container: { padding: "5px 15px", margin: "0 auto" },
    orderSelect: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px",
      border: "1px solid #999",
      borderRadius: "8px",
      margin: "5px 15px",
    },
    pagination: {
      padding: "5px 15px",
      marginBottom: "10px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
  };
  const orderHeaders = [
    { title: "نوع دستور", key: "orderName" },
    { title: "کد دستور", key: "orderCode" },
    { title: "زمان ارسال", key: "sentTime" },
    { title: "زمان دریافت", key: "reciveTime" },
    { title: "وضعیت دستور", key: "orderStatus" },
  ];
  let table_data = [];
  orders.forEach((order) =>
    table_data.push({
      orderName: order?.order_type?.order_type_name,
      orderCode: order?.order_type?.order_type_code,
      sentTime: renderTimeJalali(order?.order_create_time),
      reciveTime: renderTimeJalali(order?.order_status_time),
      orderStatus: renderStatus(order?.order_status),
    })
  );
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.header}>
        <Typography variant="h6" component="h6">
          انتخاب دستور
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.orderSelect}>
        <OrderSelect
          orderTypes={orderTypes}
          update={updateTable}
          info={deviceInfo}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.header}>
        <Typography variant="h6" component="h6">
          دستورات ارسال شده({total_orders})
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        <SimpleTable
          hasIndex={true}
          hasLink={false}
          darkHeader={true}
          data={table_data}
          header={orderHeaders}
          page={orderPage}
          count={10}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.pagination}>
        <CustomPagination
          page={orderPage}
          pageSize={10}
          totalPages={total_pages}
          changePageFunc={changePage}
          totalData={total_orders}
        />
      </Grid>
    </>
  );
};
export default DeviceOrders;
